import {
    URL_CONOCIMIENTO_IA_AMPLIAR,
    URL_CONOCIMIENTO_IA_BUSCAR_AMPLIACION,
    URL_CONOCIMIENTO_IA_GUARDAR_CORRECCIONES,
    URL_CONOCIMIENTO_IA_INICIAR_REVISION,
    URL_CONOCIMIENTO_IA_MARCAR_APLICADAS,
    URL_CONOCIMIENTO_IA_REGISTRAR_VEREDICTO
} from "../Utils/constant.js";

import { buscar } from "../../../Commons/Scripts/Utils/Buscar";

export const VEREDICTO_APROBADA = "A";
export const VEREDICTO_CORREGIDA = "C";
export const VEREDICTO_RECHAZADA = "R";

export const CORRECCION_PENDIENTE = "P";
export const CORRECCION_APLICADA = "A";

/** La respuesta a revisar con sus fuentes, el historial, el chat de origen y los permisos. */
export const iniciarRevision = (idSec) => buscar(URL_CONOCIMIENTO_IA_INICIAR_REVISION, { idSec });

/** Guarda el veredicto y devuelve la revisión ya actualizada junto con el mensaje para el usuario. */
export const registrarVeredicto = (idSec, veredicto, datos) =>
    buscar(URL_CONOCIMIENTO_IA_REGISTRAR_VEREDICTO, { idSec, veredicto, datos });

/**
 * Guarda lo corregido de los fragmentos de la documentación.
 * @param correcciones [{ FuenteId, Texto }]
 */
export const guardarCorreccionesDocumentacion = (idSec, correcciones) =>
    buscar(URL_CONOCIMIENTO_IA_GUARDAR_CORRECCIONES, { idSec, correcciones });

/** Marca correcciones como ya aplicadas en el proyecto de la documentación. */
export const marcarCorreccionesAplicadas = (idSec, fuentes) =>
    buscar(URL_CONOCIMIENTO_IA_MARCAR_APLICADAS, { idSec, fuentes });

/** El archivo de ampliación del documento elegido, con lo que ya tiene publicado. */
export const buscarAmpliacion = (idSec, documentoBase) =>
    buscar(URL_CONOCIMIENTO_IA_BUSCAR_AMPLIACION, { idSec, documentoBase: documentoBase || null });

/** Agrega el conocimiento al archivo de ampliación y lo publica en el vector store. */
export const ampliarConocimiento = (idSec, documentoBase, contenido, versionEsperada) =>
    buscar(URL_CONOCIMIENTO_IA_AMPLIAR, {
        idSec,
        documentoBase: documentoBase || null,
        contenido,
        versionEsperada: versionEsperada ?? null
    });
